import { render, staticRenderFns } from "./AtomPeriodProcesses.vue?vue&type=template&id=5258b074"
import script from "./AtomPeriodProcesses.vue?vue&type=script&lang=js"
export * from "./AtomPeriodProcesses.vue?vue&type=script&lang=js"
import style0 from "./AtomPeriodProcesses.vue?vue&type=style&index=0&id=5258b074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports